import React from "react";

import Reducer from "app/context/Reducer";
import { billInitailState } from "./bill-details/billState";
import BillReducer from "./bill-details/BillReducer";

const initialState = {
  theme: "dark",
  lang: "en",
  isLoggedIn: false,
  profileData: undefined,
  billData: undefined,
  groupsData: undefined,
  clientConfigData: undefined,
  selectedCategory: "Select Category",
  selectedBiller: "Select Biller",
  rechargeNumber: "",
  notificationsData: undefined
};

function Store(props) {
  const [state, dispatch] = React.useReducer(Reducer, initialState);
  const [billState, dispatchBillState] = React.useReducer(
    BillReducer,
    billInitailState,
  );

  function billStateValue() {
    return billState;
  }

  return (
    <StoreContext.Provider
      value={{ state, dispatch, billState, dispatchBillState, billStateValue }}
    >
      {props.children}
    </StoreContext.Provider>
  );
}

export const StoreContext = React.createContext(initialState);
export default Store;
